import axios from "axios";
import { API_BASE_URL } from "../constants/apiConstants";
import { enqueueSnackbar } from "notistack";
import {SECRET_KEY} from "../constants/encriptKey";
import { getDecryptedDataFromSessionStorage } from "../utils";

const API_URL = `${API_BASE_URL}Pacientes/`;
const accessToken = getDecryptedDataFromSessionStorage(SECRET_KEY)?.accessToken;

export async function consultaPacientes(criteria) {
  const url = `${API_URL}ConsultaPacientes`;
  try {
    const response = await axios.post(url, criteria, {
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error en el servicio consultaPacientes:", error);
    return {
      error: {
        message: error.message,
        status: error.response?.status,
        url: url,
      },
    };
  }
}

export async function consultaPaciente(idPaciente, idMedico) {
  const url = `${API_URL}ConsultaPaciente/${idPaciente}/${idMedico}`;

  try {
    const response = await axios.get(url, {
      headers: {
        accept: "text/plain",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error en el servicio consultaPaciente:", error);
    return {
      error: {
        message: error.message,
        status: error.response?.status,
        url: url,
      },
    };
  }
}

export async function creaPaciente(patientData) {
  const url = `${API_URL}CreaPaciente`;
  try {
    const response = await axios.post(url, patientData, {
      headers: {
        accept: "text/plain",
        "Content-Type": "application/json",
      },
    });
    const { data } = response;
    const { statusResult, successMessage, errors } = data;

    if (statusResult === 200) {
      enqueueSnackbar(successMessage, { variant: "success" });
    } else if (Array.isArray(errors) && errors.length > 0) {
      enqueueSnackbar(errors[0], { variant: "warning" });
    } else {
      enqueueSnackbar(successMessage, { variant: "error" });
    }
    return data;
    
  } catch (error) {
    console.error("Error en el servicio creaPaciente:", error);
    return {
      error: {
        message: error.message,
        status: error.response?.status,
        url: url,
      },
    };
  }
}

export async function actualizaPaciente(patientData) {
  const url = `${API_URL}ActualizaPaciente`;

  try {
    const response = await axios.put(url, patientData, {
      headers: {
        accept: "text/plain",
        "Content-Type": "application/json",
      },
    });
    const { data } = response;
    if (data.statusResult === 200) {
      enqueueSnackbar(data.successMessage, { variant: "success" });
    } else {
      if (Array.isArray(data.errors) && data.errors.length > 0) {
        enqueueSnackbar(data.errors[0], { variant: "warning" });
      }
    }
    return data;
  } catch (error) {
    console.error("Error en el servicio actualizaPaciente:", error);
    return {
      error: {
        message: error.message,
        status: error.response?.status,
        url: url,
      },
    };
  }
}

export async function integraBoton(data) {
  const url = `${API_BASE_URL}Receta/IntegraBoton`;

  try {
    const response = await axios.post(url, data, {
      headers: {
        accept: "text/plain",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error en el servicio integraBoton:", error);
    return {
      error: {
        message: error.message,
        status: error.response?.status,
        url: url,
      },
    };
  }
}

export async function getListFinanciadores() {
  const url = `${API_BASE_URL}backoffice/Financiadores/ConsultaFinanciadoresPorApp`;

  try {
    const response = await axios.get(url, {
      headers: {
        accept: "text/plain",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error en el servicio getListFinanciadores:", error);
    return {
      error: {
        message: error.message,
        status: error.response?.status,
        url: url,
      },
    };
  }
}
